import { useContext } from "react";
import { DollarSign } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import TableCosts from "./TableCosts";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 animate-fade-in">
                        <div className="space-y-1">
                            <span className="label-overline">Catálogo</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Gastos por Grupo
                                <DollarSign className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Investimento em tráfego diário consolidado por grupo de produtos. <span className="text-ink-4">Referência: dia anterior.</span>
                            </p>
                        </div>
                    </header>

                    <TableCosts />

                </div>
            </div>
        </div>
    );
}
